import React, { useState } from "react";
import Banner from "../banner/Banner";
import "../../styles/whoIAm.css";

import Socials from "../landingPage/Socials";
function WhoIAm() {
  const [copied, setCopied] = useState(false);
  function copyEmail() {
    setCopied(true);
    const email = document.getElementById("email");
    navigator.clipboard.writeText(email.textContent);
    console.log(email.textContent);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }
  const Checkmark = () => (
    <span style={{ width: "40px", color: "white" }}>✔️</span>
  );
  return (
    <div>
      <Banner />
      <div className="whoiam">
        <div className="languages">
          <img src={require("../../media/html-logo.png")} alt="html logo" />

          <img src={require("../../media/css-logo.png")} alt="css logo" />

          <img
            src={require("../../media/JavaScript-logo.png")}
            alt="html logo"
          />
        </div>
        <div className="paragraph">
          <p>
            &nbsp; &nbsp; &nbsp; At heart, I am a builder. I’ve built with my
            hands via landscaping and construction, I’ve built social media
            brands by engaging with influencers and creators, and I presently
            build products by applying my growing knowledge of software
            development. I appreciate the therapeutic nature of coding and the
            thrill of the chase, as I aim to not only be the best developer I
            can be, but also the best possible contributor to a purpose.
          </p>
          <p>
            &nbsp; &nbsp; &nbsp;My desire to achieve and learn opened the door
            to my love for software development, and my hunger has evolved into
            a passion for building and iterating on technical projects.
          </p>
          <p>
            &nbsp; &nbsp; &nbsp; I am a contributor and vessel for learning, who
            is compelled to give my very best effort on a daily basis. Please
            feel free to connect with me, or contact me directly with any
            available full stack development opportunities!
          </p>
          <div onClick={copyEmail} id="email-box">
            <span id="email">jonahtillman98@gmail.com</span>
            <button className="copy-button">
              {copied ? <Checkmark /> : "copy email"}
            </button>
          </div>
        </div>

        <div className="socials">
          {" "}
          <Socials />
        </div>
      </div>
    </div>
  );
}

export default WhoIAm;
